import { FormStyleContext } from "@common/contexts/FormStyle";
import { ModalContext } from "@common/contexts/Modal";
import Button from "@common/controls/Button/component";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import React, { useContext } from "react";

type CancelButtonProps = {
  caption?: string;
  className?: string;
  onClick?: () => void;
};
const CancelButton = (props: CancelButtonProps) => {
  const i18n = useI18n();

  const context = useContext(ModalContext);
  const { secondaryButtonStyle } = useContext(FormStyleContext);

  return (
    <Button
      className={classNames({ btn_styled: secondaryButtonStyle }, props.className)}
      onClick={props.onClick ?? context.closeCurrent}
      type="white"
      style={secondaryButtonStyle}
    >
      {props.caption ?? i18n.cancel}
    </Button>
  );
};

export default CancelButton;
